import { render, staticRenderFns } from "./Nonaktif.vue?vue&type=template&id=fabfbe52&scoped=true"
import script from "./Nonaktif.vue?vue&type=script&lang=js"
export * from "./Nonaktif.vue?vue&type=script&lang=js"
import style0 from "vue-select/dist/vue-select.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Nonaktif.vue?vue&type=style&index=1&id=fabfbe52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabfbe52",
  null
  
)

export default component.exports